<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">GOSSIP</span>
          <small class="d-block">DIRECTORY</small>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link " routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link active" routerLink="/platforms" (click)="isNavOpen = false">Platforms</a></li>
          <li class="nav-item">
            <a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Your Card</a>
          </li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Harships Incentives</a></li>
        </ul>
      </div>
      <div class="d-none d-md-flex align-items-center gap-2">
        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">LOGIN</a>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
        </a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ GROWTH ROADMAP ============ -->
<section class="pkg-roadmap-section">
  <div class="container">
    <h2 class="pkg-roadmap-title">
      THE MORE WE <span class="text-pink">GROW</span>, THE MORE WE <span class="text-gold">UNLOCK</span>
    </h2>

    <div class="pkg-roadmap">
      <div class="pkg-roadmap-line"></div>

      <div class="pkg-milestone" *ngFor="let m of milestones">
        <span class="pkg-milestone-count">{{ m.count }}</span>
        <span class="pkg-milestone-label">MEMBERS</span>
        <div class="pkg-milestone-icon" [ngClass]="m.tier">
          <svg class="icon" [innerHTML]="m.icon"></svg>
        </div>
        <h4 [ngClass]="m.tier">{{ m.title }}</h4>
        <p>{{ m.description }}</p>
      </div>
    </div>
  </div>
</section>


<style>
	/* ===== UMYO Gossip — Platform Cards (redesign) ===== */
	.platforms-section{
		--bg: #0a0916;
		--card: #131024;
		--card-hover: #17132b;
		--border: rgba(255,255,255,.08);
		--pink: #ff1f6d;
		--pink-soft: rgba(255,31,109,.14);
		--text: #f5f3fa;
		--text-dim: #a9a4bd;
		background: var(--bg);
	}

	.platforms-section .platform-card{
		position: relative;
		height: 100%;
		background: var(--card);
		border: 1px solid var(--border);
		border-radius: 14px;
		padding: 22px 22px 24px;
		transition: border-color .25s ease, transform .25s ease, background .25s ease;
	}
	.platforms-section .platform-card:hover{
		border-color: rgba(255,31,109,.45);
		background: var(--card-hover);
		transform: translateY(-3px);
	}

	.platforms-section .platform-card__head{
		display: flex;
		align-items: center;
		gap: 12px;
		margin-bottom: 14px;
	}
	.platforms-section .platform-card__num{
		flex: 0 0 auto;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 34px;
		height: 34px;
		border-radius: 8px;
		background: var(--pink);
		color: #fff;
		font-weight: 700;
		font-size: .85rem;
		letter-spacing: .02em;
	}
	.platforms-section .platform-card__title{
		margin: 0;
		font-size: 1.05rem;
		font-weight: 700;
		color: var(--text);
		line-height: 1.3;
	}

	.platforms-section .platform-card__media{
		display: block;
		border-radius: 10px;
		overflow: hidden;
		margin-bottom: 14px;
		border: 1px solid var(--border);
		aspect-ratio: 16/10;
	}
	.platforms-section .platform-card__media img{
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}

	.platforms-section .platform-card__tagline{
		color: var(--pink);
		font-weight: 600;
		font-size: .82rem;
		text-transform: uppercase;
		letter-spacing: .04em;
		margin-bottom: 8px;
	}

	.platforms-section .platform-card__desc p{
		color: var(--text-dim);
		font-size: .92rem;
		line-height: 1.55;
		margin-bottom: 10px;
	}
	.platforms-section .platform-card__desc strong{
		display: block;
		color: var(--text);
		font-size: .82rem;
		text-transform: uppercase;
		letter-spacing: .04em;
		margin-bottom: 8px;
	}
	.platforms-section .platform-card__list{
		list-style: none;
		margin: 0 0 6px;
		padding: 0;
	}
	.platforms-section .platform-card__list li{
		position: relative;
		padding: 6px 0 6px 20px;
		font-size: .88rem;
		color: var(--text-dim);
		border-bottom: 1px solid var(--border);
	}
	.platforms-section .platform-card__list li:last-child{ border-bottom: none; }
	.platforms-section .platform-card__list li::before{
		content: "";
		position: absolute;
		left: 0;
		top: 14px;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: var(--pink);
	}

	.platforms-section .platform-card__btn{
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-top: 14px;
		padding: 9px 18px;
		font-size: .8rem;
		font-weight: 700;
		letter-spacing: .05em;
		text-transform: uppercase;
		color: var(--pink);
		background: var(--pink-soft);
		border: 1px solid var(--pink);
		border-radius: 999px;
		cursor: pointer;
		transition: background .2s ease, color .2s ease;
	}
	.platforms-section .platform-card__btn:hover{
		background: var(--pink);
		color: #fff;
	}
</style>

<section class="platforms-section">
	<div class="container">
		<div class="platforms-heading">

	      <span class="platforms-kicker">THE UMYO ECOSYSTEM</span>

	      <h2>
	        EXPLORE OUR
	        <span>PLATFORMS</span>
	      </h2>

	      <p>
	        Everything you need to connect, create, grow, and engage
	        with the UMYO community.
	      </p>

	    </div>

		<div class="row">

			<!-- 01 Marketplace -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">01</span>
						<h3 class="platform-card__title">UMYO Gossip Marketplace</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/talk.png" alt="UMYO Gossip Marketplace">
					</a>
					<p class="platform-card__tagline">Buy, Sell, Share — Securely.</p>
					<div class="platform-card__desc" style="display:none" id="talk">
						<p>A community-driven marketplace where influencers, creators, and fans can exchange products, services, and exclusive offers in a trusted environment.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>List Merchandise or Services</li>
							<li>Verified Creator & Subscriber Accounts</li>
							<li>Secure Transaction & Communication Tools</li>
							<li>Promote Your Own Brand or Products</li>
						</ul>
						<a (click)="toggleSection('talk', false)" id="talk_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('talk', true)" id="talk_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 02 Tweets -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">02</span>
						<h3 class="platform-card__title">UMYO Gossip Tweets</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/tweets.png" alt="UMYO Gossip Tweets">
					</a>
					<p class="platform-card__tagline">Command the Conversation.</p>
					<div class="platform-card__desc" style="display:none" id="tweet">
						<p>A platform designed for content creators to post quick updates, share thoughts, or engage with followers in micro-posts. Perfect for keeping your community connected without distractions.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Share Short-Form Posts</li>
							<li>Engage with Followers in Real-Time</li>
							<li>No Ads, Just Content</li>
							<li>Moderated for Community Respect</li>
						</ul>
						<a (click)="toggleSection('tweet', false)" id="tweet_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('tweet', true)" id="tweet_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 03 Events -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">03</span>
						<h3 class="platform-card__title">UMYO Gossip Events</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/events.png" alt="UMYO Gossip Events">
					</a>
					<p class="platform-card__tagline">Host. Coordinate. Connect.</p>
					<div class="platform-card__desc" style="display:none" id="event">
						<p>Plan and manage live events, Q&As, collaborations, and special announcements with tools designed for content creators and their audiences.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Secure Event Tools for In-Person and Virtual Events</li>
							<li>Streamlined Ticketing & Promotion</li>
							<li>Interactive Engagement with Attendees</li>
							<li>Real-Time Feedback & Tracking</li>
						</ul>
						<a (click)="toggleSection('event', false)" id="event_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('event', true)" id="event_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>
		</div>

		<div class="row">

			<!-- 04 Radio -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">04</span>
						<h3 class="platform-card__title">UMYO Gossip Radio</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/radio.png" alt="UMYO Gossip Radio">
					</a>
					<p class="platform-card__tagline">Stream. Share. Engage.</p>
					<div class="platform-card__desc" style="display:none" id="radio">
						<p>Broadcast live shows, behind-the-scenes content, or motivational messages. Perfect for building deeper connections with your community through audio.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Live Streaming Channels</li>
							<li>Host Podcasts or Interviews</li>
							<li>Customizable DJ Dashboard</li>
							<li>Real-Time Viewer Interaction</li>
						</ul>
						<a (click)="toggleSection('radio', false)" id="radio_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('radio', true)" id="radio_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 05 Appointments -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">05</span>
						<h3 class="platform-card__title">UMYO Gossip Appointments</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/appointment.png" alt="UMYO Gossip Appointments">
					</a>
					<p class="platform-card__tagline">Schedule. Book. Connect.</p>
					<div class="platform-card__desc" style="display:none" id="appoint">
						<p>A professional scheduling tool for content creators, influencers, and collaborators to manage appointments, consulting sessions, and private fan meetings.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Automated Scheduling & Reminders</li>
							<li>Secure Payment & Booking System</li>
							<li>Personalizable Booking Pages</li>
							<li>Sync with Social Media Profiles</li>
						</ul>
						<a (click)="toggleSection('appoint', false)" id="appoint_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('appoint', true)" id="appoint_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 06 Music -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">06</span>
						<h3 class="platform-card__title">UMYO Gossip Music</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/music.png" alt="UMYO Gossip Music">
					</a>
					<p class="platform-card__tagline">Share Your Sound. Inspire Your Community.</p>
					<div class="platform-card__desc" style="display:none" id="music">
						<p>A music platform designed for content creators to upload, monetize, and share their tracks with subscribers. Whether you're a musician or simply sharing playlists, UMYO Gossip gives you a secure platform to connect.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Upload & Monetize Music Tracks</li>
							<li>Build & Share Playlists</li>
							<li>Collaborate with Fellow Creators</li>
							<li>Exclusive Music Discovery for Subscribers</li>
						</ul>
						<a (click)="toggleSection('music', false)" id="music_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('music', true)" id="music_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 07 Livestream -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">07</span>
						<h3 class="platform-card__title">UMYO Gossip Livestream</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/livestream.png" alt="UMYO Gossip Livestream">
					</a>
					<p class="platform-card__tagline">Broadcast with Precision.</p>
					<div class="platform-card__desc" style="display:none" id="stream">
						<p>Stream live with security and ease, whether for a gaming session, Q&A, or special event. Interact with your audience in real time to build engagement.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Secure, High-Quality Live Streams</li>
							<li>Real-Time Viewer Interactions</li>
							<li>Cross-Platform Access (Mobile & Desktop)</li>
							<li>Archival & Replay Features</li>
						</ul>
						<a (click)="toggleSection('stream', false)" id="stream_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('stream', true)" id="stream_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 08 Dating -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">08</span>
						<h3 class="platform-card__title">UMYO Gossip Dating</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/dating.png" alt="UMYO Gossip Dating">
					</a>
					<p class="platform-card__tagline">Connect with Like-minded Creators.</p>
					<div class="platform-card__desc" style="display:none" id="dating">
						<p>A private matchmaking platform for influencers and creators to connect with fans and others who share their values and passions. Build deeper connections in a safe, respectful space.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Verified Profiles for Creators & Subscribers</li>
							<li>Secure Messaging & Matchmaking Algorithms</li>
							<li>Common Interests-Based Pairing</li>
							<li>Moderated for Safety & Respect</li>
						</ul>
						<a (click)="toggleSection('dating', false)" id="dating_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('dating', true)" id="dating_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 09 Fans -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">09</span>
						<h3 class="platform-card__title">UMYO Gossip Fans</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Fans.png" alt="UMYO Gossip Fans">
					</a>
					<p class="platform-card__tagline">Support. Subscribe. Engage.</p>
					<div class="platform-card__desc" style="display:none" id="fans">
						<p>A platform that allows content creators to monetize their work by sharing premium, exclusive content with their followers. Build a community of loyal fans who support your content.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Subscription Models for Exclusive Content</li>
							<li>Direct Messaging & Engagement with Fans</li>
							<li>Promote Special Offers & Merch</li>
							<li>Analytics to Track Subscriber Growth</li>
						</ul>
						<a (click)="toggleSection('fans', false)" id="fans_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('fans', true)" id="fans_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>
		</div>

		<div class="row">

			<!-- 10 eStore -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">10</span>
						<h3 class="platform-card__title">UMYO Gossip eStore</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/estore.png" alt="UMYO Gossip eStore">
					</a>
					<p class="platform-card__tagline">Sell Your Merchandise. Support Your Brand.</p>
					<div class="platform-card__desc" style="display:none" id="store">
						<p>Create an online store to sell your unique merchandise, digital downloads, or services directly to your audience. Secure payment and inventory management tools make the process easy.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Customizable Online Storefront</li>
							<li>Inventory Management & Secure Payments</li>
							<li>Design Your Own Products (Apparel, Gear, etc.)</li>
							<li>Track Sales & Customer Interactions</li>
						</ul>
						<a (click)="toggleSection('store', false)" id="store_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('store', true)" id="store_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 11 Conferencing -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">11</span>
						<h3 class="platform-card__title">UMYO Gossip Conferencing</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/conferencing.png" alt="UMYO Gossip Conferencing">
					</a>
					<p class="platform-card__tagline">Collaborate and Innovate.</p>
					<div class="platform-card__desc" style="display:none" id="room">
						<p>Host secure video conferences for team collaborations, brainstorming sessions, or intimate fan meetings. Perfect for content creators to stay connected and organized.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Secure Video/Audio Meetings</li>
							<li>Real-Time Chat and File Sharing</li>
							<li>Screen Share and Collaboration Tools</li>
							<li>Session Recording & Replay Options</li>
						</ul>
						<a (click)="toggleSection('room', false)" id="room_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('room', true)" id="room_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 12 Video Magazine -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">12</span>
						<h3 class="platform-card__title">UMYO Gossip Video Magazine</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Video_Magazine.png" alt="UMYO Gossip Video Magazine">
					</a>
					<p class="platform-card__tagline">Create. Share. Inspire.</p>
					<div class="platform-card__desc" style="display:none" id="magazine">
						<p>Showcase your latest projects, highlight subscriber achievements, or produce special content with the video magazine feature. Perfect for content creators looking to share unique stories with their community.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Branded Video Layouts for Storytelling</li>
							<li>Subscriber Features and Spotlights</li>
							<li>Shareable Across Social Networks</li>
							<li>Video Archive for Ongoing Engagement</li>
						</ul>
						<a (click)="toggleSection('magazine', false)" id="magazine_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('magazine', true)" id="magazine_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>
		</div>

		<div class="row">

			<!-- 13 News -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">13</span>
						<h3 class="platform-card__title">UMYO Gossip News</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/News.png" alt="UMYO Gossip News">
					</a>
					<p class="platform-card__tagline">Stay Informed. Stay Ahead.</p>
					<div class="platform-card__desc" style="display:none" id="news">
						<p>A curated newsfeed focused on the latest in content creation, digital trends, and influencer culture. Stay up-to-date on everything you need to know as a creator.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Real-Time News Updates</li>
							<li>Industry-Specific Headlines</li>
							<li>Comment & Community Discussion</li>
							<li>Exclusive Creator Resources</li>
						</ul>
						<a (click)="toggleSection('news', false)" id="news_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('news', true)" id="news_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 14 Video Hosting -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">14</span>
						<h3 class="platform-card__title">UMYO Gossip Video Hosting</h3>
					</div>
					<a href="#" target="_blank" class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Video_Platform.png" alt="UMYO Gossip Video Hosting">
					</a>
					<p class="platform-card__tagline">Your Voice. Your Content.</p>
					<div class="platform-card__desc" style="display:none" id="talent">
						<p>Upload, host, and share high-quality videos with your subscribers without ads or interruptions. Whether it's for tutorials, vlogs, or fan interactions, UMYO Gossip provides the perfect platform for creators.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Ad-Free Video Hosting</li>
							<li>Role-Based Access for Team Collaboration</li>
							<li>Custom Playlists & Channel Creation</li>
							<li>Interactive Chat During Streams</li>
						</ul>
						<a (click)="toggleSection('talent', false)" id="talent_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('talent', true)" id="talent_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 15 AI Chat -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">15</span>
						<h3 class="platform-card__title">UMYO Gossip AI Chat</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/AI.png" alt="UMYO Gossip AI Chat">
					</div>
					<p class="platform-card__tagline">Your Secure AI Assistant for the Community and Beyond.</p>
					<div class="platform-card__desc" style="display:none" id="chat">
						<p>UMYO Gossip ChatGPT is a custom AI solution built for secure communication, daily updates, community news, and real-time social support—protected by UMYO's advanced encryption.</p>
						<strong>AI Capabilities Designed for You:</strong>
						<ul class="platform-card__list">
							<li>Secure, Encrypted Access for Trusted Conversations</li>
							<li>Instant Language Translation & Real-Time Updates</li>
							<li>Task Automation for Everyday Activities</li>
							<li>Accurate Q&A for News, Tips, & Community Info</li>
							<li>Optimized for Low-Bandwidth & Offline Scenarios</li>
						</ul>
						<p>Stay informed. Share openly. Connect safely—with UMYO Gossip.</p>
						<a (click)="toggleSection('chat', false)" id="chat_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('chat', true)" id="chat_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>
		</div>

		<div class="row">

			<!-- 16 Online Games -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">16</span>
						<h3 class="platform-card__title">UMYO Gossip Online Games</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Online Games.png" alt="UMYO Gossip Online Games">
					</div>
					<p class="platform-card__tagline">Game. Compete. Connect — Securely.</p>
					<div class="platform-card__desc" style="display:none" id="game">
						<p>Enjoy a curated collection of competitive online games tailored for secure personnel—accessible securely through UMYO Gossip Games. Whether for stress relief or team bonding, game without borders or risks.</p>
						<strong>Online Gaming Highlights:</strong>
						<ul class="platform-card__list">
							<li>Low-Latency Servers for Seamless Play</li>
							<li>Access Region-Locked Games Anywhere</li>
							<li>Multiplayer Matchmaking with Encrypted Privacy</li>
							<li>Squad-Based Military Strategy Titles</li>
							<li>Weekly Tournaments & Leaderboards</li>
						</ul>
						<p>Play smart. Play secure. With UMYO.</p>
						<a (click)="toggleSection('game', false)" id="game_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('game', true)" id="game_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 17 Digital Coupon Booklet -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">17</span>
						<h3 class="platform-card__title">UMYO Gossip Digital Coupon Booklet</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Video COupon Booklet.png" alt="UMYO Gossip Digital Coupon Booklet">
					</div>
					<p class="platform-card__tagline">Support Local Communities.</p>
					<div class="platform-card__desc" style="display:none" id="book">
						<p>Offer local and national discounts to families, students, and everyday shoppers through digital coupon booklets.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Geo-Targeted Promotional Ads</li>
							<li>QR Code Coupon Integration</li>
							<li>Loyalty & Rewards System</li>
							<li>Campaign Performance Tracking</li>
						</ul>
						<a (click)="toggleSection('book', false)" id="book_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('book', true)" id="book_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 18 Prize Giveaways -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">18</span>
						<h3 class="platform-card__title">UMYO Gossip Prize Giveaways</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/giveways.png" alt="UMYO Gossip Prize Giveaways">
					</div>
					<p class="platform-card__tagline">Boost Morale. Recognize Service.</p>
					<div class="platform-card__desc" style="display:none" id="prize">
						<p>Gamify promotions with giveaways that reward returning customers and encourage word-of-mouth marketing.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>Run Contests or Sweepstakes</li>
							<li>Recognize Troop Engagement</li>
							<li>Real-Time Prize Distribution</li>
							<li>Track & Analyze Results</li>
						</ul>
						<a (click)="toggleSection('prize', false)" id="prize_less_btn" class="platform-card__btn">Read Less</a>
					</div>
					<a (click)="toggleSection('prize', true)" id="prize_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 19 Men No Pause -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">19</span>
						<h3 class="platform-card__title">Men No Pause</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Gossip Men no pause.png" alt="Men No Pause">
					</div>
					<p class="platform-card__tagline">A Weekly Private Space for Men to Share, Cry, Learn, Heal & Find Purpose</p>
					<div class="platform-card__desc" style="display:none" id="men">
						<p>Behind every strong face is a man carrying weight most will never see. The Men's No Pause Circle is a confidential, judgment-free space where men—of all walks of life—can come together weekly to speak freely, feel deeply, and grow stronger as a community.</p>
						<strong>What It Is:</strong>
						<p>A secure, private online or in-person gathering space held once a week, designed exclusively for men seeking honest connection and emotional growth.</p>
						<strong>What Happens Here:</strong>
						<ul class="platform-card__list">
							<li><strong>Share:</strong> Open up about life, stress, relationships, trauma, or change.</li>
							<li><strong>Cry:</strong> Let it out. No shame. No judgment. Just truth.</li>
							<li><strong>Learn:</strong> Listen to others, hear from guest mentors, and grow together.</li>
							<li><strong>Heal:</strong> Rebuild from the inside out—with compassion and support.</li>
							<li><strong>Find Purpose:</strong> Reconnect with who you are and where you're headed.</li>
						</ul>
						<strong>Why It Matters:</strong>
						<p>Strength isn't just physical. It's emotional, relational, and spiritual. This circle is a safe space to develop that strength—with brothers who get it.</p>
						<p><strong>Private. Safe. No Titles. No Judgment. No Pause.</strong><br>Join the movement. Men. No Pause.</p>
						<button (click)="toggleSection('men', false)" id="men_less_btn" class="platform-card__btn">Read Less</button>
					</div>
					<a (click)="toggleSection('men', true)" id="men_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 20 VPN -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">20</span>
						<h3 class="platform-card__title">UMYO Gossip VPN</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/VPN.png" alt="UMYO Gossip VPN">
					</div>
					<p class="platform-card__tagline">Protect Your Privacy. Empower Your Freedom.</p>
					<div class="platform-card__desc" style="display:none" id="vpn">
						<p>DFW Community VPN provides creator-grade encryption to safeguard your digital footprint. Whether you're collaborating remotely or managing your community content, your data stays protected and private.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>One-Click Secure Connection</li>
							<li>Identity & Data Protection</li>
							<li>Global Content Access</li>
							<li>No-Logs Policy</li>
							<li>Fast, Encrypted Servers</li>
						</ul>
						<button (click)="toggleSection('vpn', false)" id="vpn_less_btn" class="platform-card__btn">Read Less</button>
					</div>
					<a (click)="toggleSection('vpn', true)" id="vpn_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

			<!-- 21 Youth -->
			<div class="col-md-4 p-3">
				<div class="platform-card">
					<div class="platform-card__head">
						<span class="platform-card__num">21</span>
						<h3 class="platform-card__title">UMYO Gossip Youth</h3>
					</div>
					<div class="platform-card__media">
						<img class="lozad" src="assets/images/PlatformsType/Youth_Bonding.png" alt="UMYO Gossip Youth">
					</div>
					<p class="platform-card__tagline">Stay Private. Stay Protected.</p>
					<div class="platform-card__desc" style="display:none" id="youth">
						<p>Secure Your Online Experience-grade encryption for all your devices.</p>
						<strong>Key Features:</strong>
						<ul class="platform-card__list">
							<li>One-Click Protection</li>
							<li>No-Logs Policy</li>
							<li>Global Content Access</li>
							<li>Fast, Reliable Servers</li>
						</ul>
						<button (click)="toggleSection('youth', false)" id="youth_less_btn" class="platform-card__btn">Read Less</button>
					</div>
					<a (click)="toggleSection('youth', true)" id="youth_more_btn" class="platform-card__btn">View More</a>
				</div>
			</div>

		</div>

	</div>
</section>

<section class="platform-final-cta">

  <div class="container">

    <div class="platform-final-card">

      <div class="platform-final-icon">

        <svg viewBox="0 0 80 80">
          <circle cx="40" cy="40" r="28"></circle>
          <circle cx="31" cy="34" r="7"></circle>
          <circle cx="49" cy="34" r="7"></circle>
          <path d="M18 57c2-9 7-13 13-13s11 4 13 13"></path>
          <path d="M36 57c2-9 7-13 13-13s11 4 13 13"></path>
        </svg>

      </div>

      <div class="platform-final-content">

        <h2>
          BUILT FOR US.
          <span>POWERED BY US.</span>
        </h2>

        <p>
          All platforms are private, secure, and built exclusively
          for our community to connect, collaborate, and create
          generational wealth.
        </p>

        <a href="/?authTab=register#register" class="platform-final-btn">
          REGISTER TODAY &amp; UNLOCK ALL PLATFORMS
        </a>

      </div>

    </div>

  </div>

</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">GOSSIP</span></div>
        </div>
        <small class="d-block pkg-footer-muted">YOUR VOICE. YOUR COMMUNITY.<br>POWERED BY UMYO.</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">QUICK LINKS</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/platforms">Platforms</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">RESOURCES</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/how-to">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">LET'S CONNECT</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>© 2026 UMYO Gossip Directory. All Rights Reserved.</small>
    </div>
  </div>
</footer>